import { renderCMSComponent } from "~/features/cms/componentFactory";
import type { CMSComponentProps } from "~/features/cms/types/props";

/**
 * JSP Bridge: Creates a CMS component from its typed props object.
 * Used by componentRegistry to mount React CMS components into JSP pages.
 * The JSP parses the serialised `bridgeCmsComponentProps` once via
 * `JSON.parse("${bridgeCmsComponentProps}")`.
 */
export const createCMSComponent = (props: CMSComponentProps) => {
  if (!props) {
    if (import.meta.env.DEV) {
      console.warn(`CMSComponent props are invalid`, props);
    }
    return;
  }

  const element = renderCMSComponent(props);
  if (!element) {
    console.error(`Could not create a CMS component for type ${props.type}`);
    return null;
  }
  return element;
};
